import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { StatusFilter } from './useBookingList';

const ORDER: StatusFilter[] = [
  'ALL',
  'PENDING',
  'COUNTER_PROPOSED',
  'CONFIRMED',
  'CANCELLATION_REQUESTED',
  'REJECTED',
  'CANCELLED',
];

type Props = {
  value: StatusFilter;
  onChange: (next: StatusFilter) => void;
};

export function BookingFilterTabs({ value, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <Tabs
      value={value}
      onChange={(_e, v: StatusFilter) => onChange(v)}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        mb: 3,
        '& .MuiTab-root': { fontWeight: 600, textTransform: 'none' },
      }}
    >
      {ORDER.map((s) => (
        <Tab
          key={s}
          value={s}
          label={s === 'ALL' ? t('bookings.filter.all') : t(`bookings.status.${s}`)}
        />
      ))}
    </Tabs>
  );
}
